export default __webpack_public_path__ + "static/media/bg-ecosystem-of-partners.f1a383ef.jpg";